import { render, staticRenderFns } from "./create-admin.vue?vue&type=template&id=32482aa3&scoped=true&"
import script from "./create-admin.vue?vue&type=script&lang=ts&"
export * from "./create-admin.vue?vue&type=script&lang=ts&"
import style0 from "./create-admin.vue?vue&type=style&index=0&id=32482aa3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32482aa3",
  null
  
)

component.options.__file = "create-admin.vue"
export default component.exports